import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment-wrapper';
import * as __NgCli_bootstrap_1 from "./app/app.browser.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
document.addEventListener("DOMContentLoaded", function () {
    __NgCli_bootstrap_2.platformBrowser()
        .bootstrapModuleFactory(__NgCli_bootstrap_1.AppBrowserModuleNgFactory)
        .then(function () {
        registerServiceWorker('rmx-v1-sw');
    })
        .catch(function (err) { return console.log(err); });
});
function registerServiceWorker(swName) {
    if (environment.sw && navigator && 'serviceWorker' in navigator) {
        navigator.serviceWorker.register("/" + swName + ".js").then(function (registration) {
            registration.addEventListener('updatefound', function () {
                var newWorker = registration.installing;
                newWorker.addEventListener('statechange', function () {
                    if (newWorker.state === 'redundant') {
                        //When state is redundant it is likely that storage is full. Safest thing to do is unregister SW
                        //and app will fall back to network on next load
                        console.log("Unregistering redundant service worker");
                        registration.unregister();
                    }
                });
            });
        }).catch(function (err) {
            console.error('[App] Service worker registration failed', err);
        });
    }
}
